module.exports = __webpack_public_path__ + "img/772.e27c3b47.jpg";